'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Start = function Start(element) {
  _classCallCheck(this, Start);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'PRIM',
    leftHandButtons: [{
      onclick: function onclick() {
        window.PRIM.navigate('/new/');
      },
      icon: '\uE0CF'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }],
    contextMenu: [{
      onclick: function onclick() {
        window.PRIM.navigate('/about/');
      },
      icon: '\uE091',
      label: 'Over PRIM'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/changecredentials/');
      },
      icon: '\uE04B',
      label: 'Wachtwoord wijzigen'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/reportpeople/');
      },
      icon: '\uE052',
      label: 'Personen rapportage'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/import/');
      },
      icon: '\uE126',
      label: 'Gegevens importeren'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/export/');
      },
      icon: '\uE065',
      label: 'Gegevens exporteren'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var button = document.createElement('button');
  button.innerHTML = 'Zoeken';
  button.onclick = function () {
    window.PRIM.navigate('/search/');
  };

  div.appendChild(button);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = Start;


//////////////////
// WEBPACK FOOTER
// ./js/modules/start/action/Start.js
// module id = 25
// module chunks = 0